<ng-container *ngIf="isLoading(); then thenTemplate; else elseTemplate"></ng-container>
<ng-template #thenTemplate>
  <div class="uk-card uk uk-card-body">
    <div class="loader">Loading...</div>
  </div>
</ng-template>
<ng-template #elseTemplate>
  <div *ngIf="!code()">
    <div *ngFor="let header of headers()">
      <div class="uk-flex uk-flex-center uk-text-bold uk-text-secondary uk-text-large">{{ header }}</div>
    </div>

    <div class="uk-flex uk-flex-column uk-flex-center">
      <div class="uk-text uk-text-secondary uk-text-meta">{{ body }}</div>
    </div>
  </div>
  <div *ngIf="code()">
    <div class="uk-flex uk-flex-column uk-flex-center">
      <div class="uk-text">{{ description }}</div>
      <h4>
        <a class="uk-link-text uk-text-primary" uk-icon="icon: link" (click)="onError()">กลับไปยังห้องสนทนา</a>
      </h4>
      <div style="margin-top: 60%;color: #efefef">error code : {{ code() }}</div>
    </div>
  </div>
  <div *ngIf="isShowButton()">
    <div class="uk-margin-large-top">
      <button class="uk-button uk-button-primary uk-border-rounded" [ngStyle]="{'background-color': getPrimaryColor()}" (click)="onAccept()">{{btnAccept()}}</button>
    </div>
    <div class="uk-margin-small-top">
      <a class="uk-link-text uk-text-primary" (click)="onSendMessage()">{{btnCancel()}}</a>
    </div>
  </div>
</ng-template>